export default __webpack_public_path__ + "static/media/Taras352.331acfe1.jpg";